// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"601":"1a088a2c","893":"667eb610"}[chunkId] + ".css";
};